import { render } from "./SuplierAccount.vue?vue&type=template&id=286eccf2"
import script from "./SuplierAccount.vue?vue&type=script&lang=js"
export * from "./SuplierAccount.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__